import React from 'react';
import { Card } from 'semantic-ui-react';
import ModelPricesTable from '../../components/ModelPricesTable';
import { useTranslation } from 'react-i18next';

const ModelPrice = () => {
  const { t } = useTranslation();

  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>{t('model_price.title')}</Card.Header>
          <Card.Description style={{ marginBottom: '1em', color: '#888' }}>
            {t('model_price.description')}
          </Card.Description>
          <ModelPricesTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default ModelPrice;
